import { Component, Inject } from "@angular/core";
import { SafeUrl } from "@angular/platform-browser";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { ImagePrintService } from '../../../services/image-print.service';

export class MedicalOrderScannZoomDialogRequest {
  url: SafeUrl;
  base64: string;
}

@Component({
  selector: 'medical-order-scann-zoom-dialog',
  templateUrl: 'medical-order-scann-zoom-dialog.component.html',
  styleUrls: ['./medical-order-scann-zoom-dialog.component.css']
})
export class MedicalOrderScannZoomDialogComponent {

  constructor(public dialogRef: MatDialogRef<MedicalOrderScannZoomDialogComponent>
    , private imagePrintService: ImagePrintService
    , @Inject(MAT_DIALOG_DATA) public data: MedicalOrderScannZoomDialogRequest) {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  async print() { 
    const base64 =  this.data.base64;   
    this.imagePrintService.base64ToImagePrint(base64,'', true); 
  }

}
